import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HousingElementComponent } from './housing-element/housing-element.component';
import { HousingSearchComponent } from './housing-search/housing-search.component';
import {SharedModule} from "../../../shared/shared/shared.module";
import {TabsModule} from "ngx-bootstrap";
import {RouterModule} from "@angular/router";
import {ReactiveFormsModule} from "@angular/forms";
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot()
  ],
  declarations: [HousingElementComponent, HousingSearchComponent]
})
export class HousingSearchModule { }
